import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { Box } from '@mui/material';
import { FC } from 'react';
import { colorTokens } from '../tokens';

const ICON_SIZE = 18;

export const AppCheckboxUncheckedIcon: FC = () => (
  <Box
    component="span"
    sx={{
      width: ICON_SIZE,
      height: ICON_SIZE,
      borderRadius: '4px',
      border: `1px solid ${colorTokens.gray400Alpha18}`,
      backgroundColor: colorTokens.whiteAlpha03,
      display: 'inline-block',
      boxSizing: 'border-box'
    }}
  />
);

export const AppCheckboxCheckedIcon: FC = () => (
  <Box
    component="span"
    sx={{
      width: ICON_SIZE,
      height: ICON_SIZE,
      borderRadius: '4px',
      border: `1px solid ${colorTokens.blue300Alpha92}`,
      background: `linear-gradient(160deg, ${colorTokens.blue700Alpha84}, ${colorTokens.blue800Alpha84})`,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box'
    }}
  >
    <CheckRoundedIcon sx={{ fontSize: 14, color: '#fff' }} />
  </Box>
);
